import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function addressSearchReducer(state = initialState.userAddressSearchResults, action) {
    switch (action.type) {
        case types.SEARCH_USER_PROFILE_ADDRESS_SUCCESS:
            return action.addresses;
        case types.CLEAR_USER_PROFILE_ADDRESS_SEARCH_RESULT:
            return [];
        case types.PRELOAD_USER_PROFILE_ADDRESS_SUCCESS:
            return action.addresses;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/user/userAddressSearchReducer.js